var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "flex-column ai-center jc-center hp-10" }, [
      !_vm.isSuccessScreen
        ? _c("img", { staticClass: "w-5", attrs: { src: _vm.pathImage } })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("div", {
        staticClass: "description fs-3 gray-60 m-0 mb-3 flex-column ai-center",
        domProps: { innerHTML: _vm._s(_vm.description) }
      }),
      _vm._v(" "),
      !_vm.isSuccessScreen
        ? _c(
            "a",
            {
              staticClass: "btn btn-primary mt-5",
              attrs: { href: "https://go.sellsy.com/" }
            },
            [_vm._v(_vm._s(_vm.$l10n.__("Retourner sur le site")))]
          )
        : _c(
            "div",
            { staticClass: "prelative wp-10 mt-5" },
            [_c("preloader", { attrs: { display: true } })],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }